const searchToggles = document.getElementsByClassName('search-toggle');
const searchModal = document.getElementById('search-modal');
let searchVisible = false;

const startShowing = () => {
  document.body.classList.add('no-scroll');
  searchModal.classList.add('search-visible');
  searchModal.classList.add('search-active');
  setTimeout(endShowing, 800);
}

const endShowing = () => {
  searchVisible = true;
  document.getElementById('s').focus();
};

const startHiding = () => {
  document.body.classList.remove('no-scroll');
  searchModal.classList.remove('search-active');
  searchModal.classList.add('search-hiding');
  setTimeout(endHiding, 800);
};

const endHiding = () => {
  searchModal.classList.remove('search-hiding');
  searchModal.classList.remove('search-visible');
  searchVisible = false;
};

const toggleSearch = () => {
  searchVisible ? startHiding() : startShowing();
};

const init = () => {
  if (searchToggles) {
    Array.from(searchToggles).forEach((el) => {
      el.addEventListener('click', (el) => toggleSearch(), false);
    });
  }
};

module.exports = {
  init
};



// WEBPACK FOOTER //
// ./src/js/vanilla/search-modal.js